export default "assets/images/icons/recenter-ad23cd92.svg";